import { AxiosInstance } from "axios";
import { Localite } from "../types/Localite";

export const localiteService = {
  getAll: async (api: AxiosInstance): Promise<Localite[]> => {
    try {
      const response = await api.get('/localite');
      return response.data as Localite[];
    } catch (error: any) {
      console.error('Erreur lors de la récupération des localités :', error);
      return [];
    }
  }
};
